import { derived } from "svelte/store";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

import ExpenseStore from "../expenseStore";

let YearsList = derived(ExpenseStore, ($ExpenseStore) => {
	let completeList = [];
	let orderedMonths = [
		"jan",
		"feb",
		"mar",
		"apr",
		"may",
		"jun",
		"jul",
		"aug",
		"sep",
		"oct",
		"nov",
		"dec",
	];
	let orderedDates = [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21,
		22,
		23,
		24,
		25,
		26,
		27,
		28,
		29,
		30,
		31,
	];
	//console.log($ExpenseStore.data);

	if (_.has($ExpenseStore.data, "history")) {
		if (_.has($ExpenseStore.data.history, "yearsList")) {
			const years = _.reverse($ExpenseStore.data.history.yearsList);

			years.forEach((item) => {
				let year = item;
				let monthsList = [];
				const currentYear = new Date().getFullYear();
				let activeYear;
				if (currentYear == item) {
					activeYear = true;
				} else {
					activeYear = false;
				}

				orderedMonths.forEach((item) => {
					let daysList = [];

					if (_.has($ExpenseStore.data.history[year].monthsList, item)) {
						let month = item;
						let active;
						const currentMonth = new Date().getMonth();

						if (orderedMonths[currentMonth] == month) {
							active = true;
						} else {
							active = false;
						}

						orderedDates.forEach((item) => {
							if (
								_.includes(
									$ExpenseStore.data.history[year][month].daysList,
									item,
									0
								)
							) {
								//console.log('has item = ',item);
								//console.log($ExpenseStore.data.history[year][month][item]);
								let total = 0;
								$ExpenseStore.data.history[year][month][item].forEach(
									(item) => {
										total += item.expenseAmount;
									}
								);

								let RecordList = [];

								$ExpenseStore.data.history[year][month][item].map((item) => {
									if (item.expenseDate.seconds) {
										RecordList.push({
											expenseAmount: item.expenseAmount,
											expenseCatagory: item.expenseCatagory,
											expenseDate: item.expenseDate.toDate(),
											expenseTitle: item.expenseTitle,
											recordId: item.recordId,
											selectedBank: item.selectedBank,
											timeStamp: item.timeStamp.toDate(),
										});
									} else {
										RecordList.push({
											expenseAmount: item.expenseAmount,
											expenseCatagory: item.expenseCatagory,
											expenseDate: item.expenseDate,
											expenseTitle: item.expenseTitle,
											recordId: item.recordId,
											selectedBank: item.selectedBank,
											timeStamp: item.timeStamp,
										});
									}
								});

								daysList.push({
									collapseId: `collapseId-${uuidv4()}`,
									date: item,
									month: month,
									total: total,
									recordList: RecordList,
								});
							}
						});

						monthsList.push({
							collapseId: `collapseId-${uuidv4()}`,
							name: month,
							total: $ExpenseStore.data.history[year].monthsList[item],
							active: active,
							daysList: daysList,
						});

						//console.log(monthsList);
					}
				});

				completeList.push({
					collapseId: `collapseId-${uuidv4()}`,
					name: year,
					total: $ExpenseStore.data.history[item].total,
					active: activeYear,
					monthsList: monthsList,
				});
			});
		}
	}

	return completeList;
});

export default YearsList;
